import { render, staticRenderFns } from "./rateManagement.vue?vue&type=template&id=bc064fc4&scoped=true&"
import script from "./rateManagement.vue?vue&type=script&lang=js&"
export * from "./rateManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc064fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc064fc4')) {
      api.createRecord('bc064fc4', component.options)
    } else {
      api.reload('bc064fc4', component.options)
    }
    module.hot.accept("./rateManagement.vue?vue&type=template&id=bc064fc4&scoped=true&", function () {
      api.rerender('bc064fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/rateManagement.vue"
export default component.exports